export default class CreateAvailabilityRestrictionPeriodRequest {
    startAt: Date;
    endAt: Date;
}